import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-form-submitted-success',
  templateUrl: './form-submitted-success.component.html',
  styleUrls: ['./form-submitted-success.component.css']
})
export class FormSubmittedSuccessComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
